<template>
  <div class="text-left">
    <span v-html="$t('cookies-1')"></span>
    <span v-html="$t('cookies-1txt')"></span>
    <span v-html="$t('cookies-2')"></span>
    <span v-html="$t('cookies-2txt')"></span>
    <span v-html="$t('cookies-3')"></span>
    <span v-html="$t('cookies-3txt')"></span>
    <span v-html="$t('cookies-4')"></span>
    <span v-html="$t('cookies-4txt')"></span>
    <span v-html="$t('cookies-5')"></span>
    <span v-html="$t('cookies-5txt')"></span>
    <span v-html="$t('cookies-5table')"></span>
    <span v-html="$t('cookies-6')"></span>
    <span v-html="$t('cookies-6txt')"></span>
    <span v-html="$t('cookies-7')"></span>
    <span v-html="$t('cookies-7txt')"></span>
    <span v-html="$t('cookies-8')"></span>
    <span v-html="$t('cookies-8txt')"></span>
    <span v-html="$t('cookies-8txt2')"></span>
    <span v-html="$t('cookies-8txt3')"></span>
    <span v-html="$t('cookies-8txt4')"></span>
    <span v-html="$t('cookies-8txt5')"></span>
    <span v-html="$t('cookies-9')"></span>
    <span v-html="$t('cookies-9txt')"></span>
    <span v-html="$t('cookies-10')"></span>
    <span v-html="$t('cookies-10txt')"></span>
    <span v-html="$t('cookies-11')"></span>
    <span v-html="$t('cookies-11txt')"></span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  /deep/ table {
    width: 100%;
    td {
      padding: 0.5rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/CookiesPolicy.vue